import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PreLoaderWidget from 'components/Loader';
import VerticalLayout from 'components/AppLayout/Layouts/Vertical';

import ProtectedRoutes from './ProtoctedRoutes';

const Authorization = React.lazy(() => import('routes/Authorization'));
const Dashboard = React.lazy(() => import('routes/Dashboard'));

const Routes = () => (
    <Suspense fallback={<PreLoaderWidget/>}>
        <Switch>
            <Route path="/account" component={Authorization}/>
            <VerticalLayout>
                <Route path="/" exact component={Dashboard}/>
                <ProtectedRoutes/>
            </VerticalLayout>
        </Switch>
    </Suspense>
);
export default Routes;
